<template>
  <div class="modal" :class="{ 'is-active': isVisible }">
    <div class="modal-background" @click="$emit('close')"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
        <button class="delete" aria-label="close" @click="$emit('close')"></button>
      </header>
      <section class="modal-card-body">

        <div v-if="field === 'status'" class="field">
          <label class="label">Status</label>
          <multiselect
            v-model="selectedStatus"
            :options="statusOptions"
            :close-on-select="true"
            placeholder="Select a status"
          ></multiselect>
        </div>

      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary" @click="save" :disabled="!canSave">Apply</button>
        <button class="button" @click="$emit('close')">Cancel</button>
      </footer>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'PitchBulkEditModal',

  components: {
    Multiselect
  },

  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    field: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      selectedStatus: null,
      statusOptions: ['Sent Pitch', 'Played Live', 'Pass', 'Took Copy', 'Request Hold', 'Cut']
    }
  },

  computed: {
    title() {
      const titles = {
        status: 'Change Status'
      }
      return titles[this.field] || 'Bulk Edit'
    },

    canSave() {
      if (this.field === 'status') return !!this.selectedStatus
      return false
    }
  },

  watch: {
    isVisible(newVal) {
      if (!newVal) this.reset()
    }
  },

  methods: {
    save() {
      if (!this.canSave) return

      if (this.field === 'status') {
        this.$emit('save', { field: 'status', value: this.selectedStatus })
      }
    },

    reset() {
      this.selectedStatus = null
    }
  }
}
</script>

<style scoped>
.modal-card-body {
  overflow: visible;
}
</style>
